﻿import { ICenterBase } from '../center-base';
import { IMicrositeRecipientImage } from './microsite-recipient-image';
import { IMicrositeRecipientLog } from './microsite-recipient-log';

export interface IMicrositeRecipientLinkedEntityList {
    type: string,
    entityId: number,
    recpAlias: string,
    centerId: number
}